// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    height: '100%',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    [theme.breakpoints.down(650)]: {
      alignItems: 'flex-start',
    },
  },
  marginVertical: {
    [theme.breakpoints.down(650)]: {
      margin: '20px 0',
    },
    [theme.breakpoints.down(500)]: {
      margin: '60px 0',
    },
  },
  marginBottom: {
    [theme.breakpoints.down(650)]: {
      marginBottom: 30,
    },
  },
  imagesAndTotalDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down(650)]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  totalAndDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down(650)]: {
      alignItems: 'flex-start',
      marginLeft: 5,
    },
  },
  basketTotalText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  basketTotalDescriptionText: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '13px 13px 0 13px',
    position: 'absolute',
    bottom: -13,
    right: 7,
    [theme.breakpoints.down(650)]: {
      left: 10,
    },
  },
  isAll: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  isAllBorder: {
    borderColor: `${GlobalStyles.color.COLOR_GREEN} transparent transparent transparent`,
  },
  isNotAll: {
    backgroundColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
  },
  isNotAllBorder: {
    borderColor: `${GlobalStyles.color.COLOR_YELLOW_SELECT} transparent transparent transparent`,
  },
  helperContainer: {
    padding: '5px 10px',
    position: 'relative',
    borderRadius: 10,
    marginBottom: 2,
    marginRight: 0,
    [theme.breakpoints.down(650)]: {
      padding: '7px 15px',
      marginRight: 0,
      marginLeft: -5,
    },
  },
  helperText: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  clearButtonContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 10,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    border: 'none',
    margin: 1,
    '&:focus': {
      outline: 'none',
    },
    '&:hover': {
      borderRadius: 10,
      borderLeft: '1px red solid',
      borderRight: '1px red solid',
    },
    [theme.breakpoints.down(650)]: {
      marginLeft: 5,
    },
  },
  clearText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    paddingRight: 2,
  },
  openBox: {
    width: 40,
    height: 40,
  },
  clearBasket: {
    width: 18,
    height: 18,
    margin: 5,
  },
  inputStyle: {
    marginTop: 10,
    backgroundColor: 'rgb(230, 230, 230)',
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    width: 150,
    '&::-webkit-input-placeholder': {
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
      color: 'rgb(150, 150, 150)',
    },
    '&::placeholder': {
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
      color: 'rgb(150, 150, 150)',
    },
    [theme.breakpoints.down(400)]: {
      marginTop: 10,
      width: 280,
    },
  },
});

export default styles;
